import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['timeDisplay'];

  connect() {
    App.afterTimeLog = (App.afterTimeLog || []).concat([this.updateTaskTime.bind(this)]);
  }

  updateTaskTime({ task_id }) {
    if (task_id && this.timeDisplayTarget && this.timeDetailsURL)
      xhrRequest(this.timeDetailsURL, 'get').then(({ data }) => this.timeDisplayTarget.innerHTML = data);
  }

  get timeDetailsURL() {
    return this.data.get('time-details-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/tasks/task-details-list-controller.js